



const LoadBar = ({leftContet, rightContent, progress}) => {

    const getProgressColor = (progress) => {
        if (progress <= 25) return "#FF0000"; // Vermelho
        if (progress <= 50) return "#F6921E"; // Laranja
        if (progress <= 75) return "#FDC24E"; // Amarelo
        return "#00C64C"; // Verde
    };

    const progressColor = getProgressColor(progress || 0);

    return (
        <>
        <div className="flex justify-between mb-1 ">
            <span className="text-base font-medium text-blue-700 ">{leftContet}</span>
            <span className="text-sm font-medium text-blue-700 ">{rightContent}</span>
        </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5 ">
            <div 
                className=" h-2.5 rounded-full" 
                style={{
                    width: `${progress || 0}%`,
                    transition: "width 0.5s, background-color 0.5s",
                    backgroundColor: progressColor,
                }}
            ></div>
        </div>
        </>
    )
}


export default LoadBar